window.addEventListener('load', function (event) {
  const formFeedback = document.querySelector('[data-feedback]');
  if (formFeedback) {
    const container = document.querySelector("[data-notification='container']");
    const backdrop = document.querySelector("[data-notification='backdrop']");
    const modal = document.querySelector("[data-notification='modal']");
    const title = modal.querySelector("[data-notification='title']");
    const message = modal.querySelector("[data-notification='message']");

    const shown = container.dataset.hasOwnProperty('shown') ? container.dataset.shown : 'notification-default-shown';
    const hidden = container.dataset.hasOwnProperty('hidden')
      ? container.dataset.hidden
      : 'notification-default-hidden';

    title.textContent = formFeedback.dataset.title;
    message.textContent = formFeedback.dataset.message;

    container.classList.replace(hidden, shown);

    formFeedback.parentElement.removeChild(formFeedback);

    const closeModal = modal.querySelector("[data-notification='close']");
    closeModal.addEventListener('click', function (ev) {
      container.classList.replace(shown, hidden);
      modal.parentElement.removeChild(modal);
    });
    backdrop.addEventListener('click', function (ev) {
      container.classList.replace(shown, hidden);
      modal.parentElement.removeChild(modal);
    });
  }
});
